<div class="card default" *ngIf="isShowNotice">
  <div class="card-header">
    <div class="row justify-content-between align-items-center mb-2">
      <div class="col">
        <strong class="card-title">
          {{ "LABELS.ISF" | translate | uppercase }}
        </strong>
      </div>
      <div class="isf-actions">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </div>
    </div>

    <div class="d-flex">
      <div class="title-block" *ngIf="isf.referenceNumber">
        <div class="card-header-date">{{ "LABELS.EEZY_ID" | translate }}</div>
        <div class="card-header-text">
          <strong>{{ isf.referenceNumber }}</strong>
        </div>
      </div>

      <div class="title-block pl-3">
        <div class="card-header-date" *ngIf="isf.transactionNumber">{{ "LABELS.CBP_ID" | translate }}</div>
        <div class="card-header-text" *ngIf="isf.transactionNumber">
          <strong>{{ isf.transactionNumber }}</strong>
        </div>
      </div>

      <div class="title-block pl-3">
        <ng-template [ngIf]="isf.sentToProviderDate || isf.receivedByCbpDate">
          <div class="card-header-date">
            {{
              (isf.receivedByCbpDate
                ? isDeletedStatus
                  ? "LABELS.DELETED_BY_CBP"
                  : "STATUS.SECOND_TEXT.RECEIVED_BY_CBP"
                : "LABELS.SENT_TO_PROVIDER"
              ) | translate
            }}
          </div>
          <div class="card-header-text">
            <strong>{{ (isf.receivedByCbpDate ? isf.receivedByCbpDate : isf.sentToProviderDate) | customDateByUtc }}</strong>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="card-body-status">
      <isf-status [state]="isf.state" [paymentState]="isf.paymentState" [isf]="isf"></isf-status>
    </div>
    <div
      class="card-body-text"
      *ngIf="showText"
      [ngClass]="{ 'text-error': state === enumIsfState.NOT_VALID_AT_PROVIDER || state === enumIsfState.UNRECOVERABLE }"
    >
      <span [innerHTML]="cardBodyText | translate : { code: 'ISF' }"></span>

      <app-hint-tooltip-icon *ngIf="isShowCustomStateTooltip" [hint]="isf?.customState?.internalNotes | translate"></app-hint-tooltip-icon>
    </div>
    <div *ngIf="isShowLoader" class="loader-wrapper">
      <img src="/assets/images/loading.gif" />
    </div>
    <ul *ngIf="messages.length" class="messages-list">
      <li *ngFor="let message of messages" class="messages-item">
        <span *ngIf="showTranslatedKey(message)" [innerHTML]="message.key | translate : message.params"></span>
        <span *ngIf="getCodeStepForMessage(message.initialMessage)" class="action-link" (click)="messageClick(message)">
          {{ "BUTTON.UPDATE_HERE" | translate }}
        </span>
        <span *ngIf="registerMessage(message)">
          {{
            registerMessage(message) | translate : { code: "LABELS.ISF" | translate, entityType: getEntityTypeText(message) | translate }
          }}
        </span>
      </li>
    </ul>
    <div *ngIf="isShowCbpLogButton || (isShowSupport && showContactTeem)" class="d-flex justify-content-between">
      <div>
        <button class="btn btn-link" (click)="toggleCbpLog()" *ngIf="isShowCbpLogButton">{{ "BUTTON.CBP_LOG" | translate }}</button>
      </div>
      <div *ngIf="showOpenDocumentLink">
        <button class="btn btn-link" (click)="openDocumentsChange.emit(!openDocuments)">
          {{ (openDocuments ? "BUTTON.CLOSE_DOCUMENTS" : "BUTTON.OPEN_DOCUMENTS") | translate }}
        </button>
      </div>
      <div>
        <button class="btn btn-link" (click)="contactToSupport()" *ngIf="isShowSupport && showContactTeem">
          {{ "BUTTON.CONTACT_SUPPORT" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<!--<ng-template #cardAlert>-->
<!--  <div class="card-header">-->
<!--    <div class="card-header-text" *ngIf="cardHeaderText">-->
<!--      <i class="icon-ic_simn"></i>-->
<!--      {{ cardHeaderText | translate }}-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="card-body">-->
<!--    <div class="card-body-text">-->
<!--      {{ cardBodyText | translate: { code: 'ISF' } }}-->
<!--      <div class="actions" *ngIf="isShowSupport && showContactTeem">-->
<!--        <button class="btn btn-link" (click)="contactToSupport()">{{ 'BUTTON.CONTACT_SUPPORT' | translate }}</button>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</ng-template>-->
<info
  *ngIf="showHeaderOnDraft && !isShowNotice"
  [title]="(info.title | translate) + ': ' + isf.referenceNumber || ''"
  [subTitle]="info.subTitle"
>
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</info>
<ng-container *ngIf="isShowAttention">
  <div class="card warning">
    <div class="card-header">
      <div class="card-header-text">
        <i class="icon-ic_simn"></i>
        {{ cardHeaderAttention | translate }}
      </div>
    </div>
    <div class="card-body">
      <div class="card-body-text">
        <span>
          {{ cardBodyAttention | translate }}
          <span class="action-link" (click)="goToUpdateLS()">{{ "BUTTON.UPDATE_HERE" | translate }}</span>
        </span>
      </div>
    </div>
  </div>
</ng-container>

<div *ngIf="isShowCbpLog" class="summary-card p-3">
  <div *ngIf="isShowCbpLogLoader; else cbpMessageList" class="loader-wrapper">
    <img src="/assets/images/loading.gif" />
  </div>
  <ng-template #cbpMessageList>
    <div class="w-100">
      <cbp-log-message-list [sendToProviderDate]="isf.sentToProviderDate" [messageList]="cbpLogMessages"></cbp-log-message-list>
    </div>
  </ng-template>
</div>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
